import { render } from "./updateDIDNumberPopUp.vue?vue&type=template&id=2e39a120"
import script from "./updateDIDNumberPopUp.vue?vue&type=script&lang=js"
export * from "./updateDIDNumberPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__